<template>
    <el-dialog
        :visible.sync="invoiceVisible"
        width="468px"
        title="发票详情"
        :show-close="true"
        :before-close="handleClose"
        :close-on-click-modal="true"
        :lock-scroll="true"
        class="invoiceInfoBox"
    >
        <el-form
            :model="formData"
            ref="formData"
            label-width="120px"
            label-position="right"
            status-icon
        >
            <el-form-item label="发票抬头:" prop="status">
                <el-radio-group v-model="formData.status" :disabled="true">
                    <el-radio :label="'0'">个人</el-radio>
                    <el-radio :label="'1'">单位</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="发票类型:"> 电子发票 </el-form-item>
            <el-form-item
                label="姓名:"
                prop="userName"
                v-if="formData.status === '0'"
                key="userName"
            >
                <el-input v-model="formData.userName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item
                label="单位名称:"
                prop="companyName"
                v-if="formData.status === '1'"
                key="companyName"
            >
                <el-input v-model="formData.companyName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item
                label="纳税人识别号:"
                prop="invoiceNum"
                v-if="formData.status === '1'"
                key="invoiceNum"
            >
                <el-input v-model="formData.invoiceNum" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item
                label="联系电话:"
                prop="phone"
                key="phone"
                v-if="formData.status === '0'"
            >
                <el-input v-model="formData.phone" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item
                label="联系电话:"
                prop="companyPhone"
                key="companyPhone"
                v-if="formData.status === '1'"
            >
                <el-input v-model="formData.companyPhone" :disabled="true"></el-input>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
export default {
    props: {
        //dialog 开关
        invoiceVisible: {
            type: Boolean,
            default: false,
        },
        //发票信息
        invoiceInfo: {
            type: Object,
            default() {},
        },
        //关闭dialog
        remoteInvoiceClose: Function,
    },
    data() {
        return {
            formData: {
                status: null,
                userName: "",
                companyName: "",
                phone: "",
                companyPhone: "",
                invoiceNum: "",
            },
        };
    },
    methods: {
        //关闭dialog
        handleClose() {
            this.remoteInvoiceClose();
        },
    },
    watch: {
        invoiceVisible: {
            handler(newValue) {
                if (newValue) {
                    this.formData.status = this.invoiceInfo.titleType;
                    this.formData.userName = this.invoiceInfo.titleType == '0' ? this.invoiceInfo.titleName : '';
                    this.formData.companyName = this.invoiceInfo.titleType == '0' ? '' : this.invoiceInfo.titleName;
                    this.formData.phone = this.invoiceInfo.titleType == '0' ? this.invoiceInfo.phoneNumber : '';
                    this.formData.companyPhone = this.invoiceInfo.titleType == '0' ? '' :  this.invoiceInfo.phoneNumber;
                    this.formData.invoiceNum = this.invoiceInfo.titleType == '0' ? '' :  this.invoiceInfo.taxNumber;
                }
            },
        },
    },
};
</script>

<style>
.el-dialog__body {
    padding: 20px;
}
.btnBox .el-form-item__content {
    margin-left: 0 !important;
    text-align: center;
}
.invoiceInfoBox .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #b21f27;
}
.invoiceInfoBox .el-checkbox__input.is-focus .el-checkbox__inner,
.invoiceInfoBox .el-checkbox__inner:hover {
    border-color: #b21f27;
}
.invoiceInfoBox .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #b21f27;
    background: #b21f27;
}
.invoiceInfoBox .el-radio__inner:hover {
    border-color: #b21f27;
}
.invoiceInfoBox .el-radio__input.is-checked + .el-radio__label {
    color: #b21f27;
}
.invoiceInfoBox .el-radio__input.is-checked .el-radio__inner {
    border-color: #b21f27;
    background: #b21f27;
}
.invoiceInfoBox .el-input__inner:hover,
.invoiceInfoBox .el-input__inner:focus {
    border-color: #b21f27;
}
.invoiceInfoBox .el-dialog__header span {
    font-size: 24px;
}
.invoiceInfoBox .el-dialog__header {
    background: #fff1f2;
}
</style>
